/**
 * Brand copy repeated verbatim across the app. The tagline prints on the masthead, the age gate
 * and the homepage, and having it typed out three times is how it drifted to two different
 * apostrophes between them — a curly one here, an HTML entity there, one character apart and
 * invisible on review. One constant, one apostrophe, three importers.
 */
export const HOME_TAGLINE = 'Ensure your expectation …it’s Essential';
